module.exports = __webpack_public_path__ + "img/issac-pro.83336b70.jpg";